class ProgressUtils{
    
    /**
     * Fills the chunks array up to the specified index with a background color.
     *
     * @param {Array} chunks - An array of elements to be filled.
     * @param {number} index - The index up to which the chunks should be filled.
     */
    static fillChunks(chunks, index){
        if(chunks[index]){
            for(let i = index; i >= 0; i--){
                chunks[i].style.backgroundColor = '#F5CF73';
            }
        }
    }

    /**
     * Builds a progress bar by appending cloned nodes to a container.
     *
     * @param {number} total - The total number of nodes to append.
     * @param {HTMLElement} container - The container element to which the nodes will be appended.
     * @param {HTMLElement} node - The node to be cloned and appended to the container.
     * @returns {HTMLCollection} The collection of child elements appended to the container.
     */
    static buildProgressBar(total, container, node){
        for(let i = 0; i < total; i++){
            container.appendChild(node.cloneNode(true));
        }
        return container.children;
    }
}

class ProgressFrameFinder extends HTMLElement {
    constructor() {
        super();
        this.container      = this.querySelector('.progress-chunks');
        this.progressChunk  = this.querySelector('.progress-chunk');
        this.index          = parseInt(this.dataset.index);
    }

    connectedCallback() {
        subscribe('frame-finder-progress-builder', (total) => {
            const progressChunks = ProgressUtils.buildProgressBar(total - 1, this.container, this.progressChunk);
            ProgressUtils.fillChunks(progressChunks, this.index - 1);
        });
    }
}

customElements.define('progress-frame-finder', ProgressFrameFinder);

